'use client';

import type { ReactNode } from 'react';
import type { LocaleT } from '../../config/locale';

import TokenRefreshInterval from '../../component/client/auth/TokenRefreshInterval';
import DevToolsProvider from '@vs-shop/rcprofi-devtools/DevToolsProvider';

import { AnnouncementProvider } from '@vs-shop/headless/announcements/AnnouncementProvider';
import { announcementAtoms } from '../../effect/atom/alertMessages/alertMessages';

import IntlByLocaleProvider from './IntlByLocaleProvider';
import { RegistryProvider } from '@effect/atom-react';

export function AllProviders({ locale, children }: { locale: LocaleT; children: ReactNode }) {
  return (
    <IntlByLocaleProvider locale={locale}>
      <AnnouncementProvider atoms={announcementAtoms}>
        <RegistryProvider key={locale}>
          <DevToolsProvider>
            <TokenRefreshInterval />
            {children}
          </DevToolsProvider>
        </RegistryProvider>
      </AnnouncementProvider>
    </IntlByLocaleProvider>
  );
}
